import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

const HoverIcon = ({ children, icon, ...props }) => {
  return (
    <div className="HoverIcon__root" {...props}>
      {children}
      <i
        className={`${icon || 'icon-generalarrowesmall'} HoverIcon__hoverIcon`}
      />
    </div>
  );
};

HoverIcon.propTypes = {
  children: PropTypes.node,
};

HoverIcon.defaultProps = {
  children: undefined,
};

export default HoverIcon;
